'use client'

import React from "react"

import { Bell, Settings, User, Power } from 'lucide-react'
import { ThemeToggle } from './theme-toggle'

interface HeaderProps {
  title: string
  subtitle?: string
  actions?: React.ReactNode
}

export function Header({ title, subtitle, actions }: HeaderProps) {
  return (
    <header className="bg-card border-b border-border h-16 flex items-center justify-between px-8 fixed top-0 right-0 left-56">
      <div>
        <h1 className="text-xl font-semibold text-foreground">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground">{subtitle}</p>}
      </div>

      <div className="flex items-center gap-4">
        {actions}
        <div className="flex items-center gap-2 ml-4 pl-4 border-l border-border">
          <ThemeToggle />
          <button className="p-2 hover:bg-secondary rounded-lg transition-colors">
            <Bell size={20} className="text-foreground" />
          </button>
          <button className="p-2 hover:bg-secondary rounded-lg transition-colors">
            <User size={20} className="text-foreground" />
          </button>
          <button className="p-2 hover:bg-secondary rounded-lg transition-colors">
            <Settings size={20} className="text-foreground" />
          </button>
        </div>
      </div>
    </header>
  )
}
